export enum UserType {
  Director = 'sales_director',
  Manager = 'sales_manager',
  Consultant = 'consultant',
}
